"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomWebsocket = void 0;
var netcheck_1 = require("@tencent/netcheck");
var axios_1 = __importDefault(require("axios"));
var config_1 = require("../../socket.io/config");
var socket_io_client_1 = __importDefault(require("../../socket.io/socket.io/socket.io-client"));
var util_1 = require("../../util");
var collab_room_reporter_1 = __importDefault(require("../../report/collab-room-reporter"));
// socket.io 默认使用第一个模式
var transportsIndex = 0;
var APPID_QUERY_KEY = '_o_appId';
/**
 * 管理socket.io对象，处理各种事件
 *
 * @class RoomWebsocket
 * @extends {IDisposable}
 */
var RoomWebsocket = /** @class */ (function () {
    function RoomWebsocket(option) {
        var _this = this;
        this.option = option;
        // 每一个socket对象随机一个
        this.socketId = String(Math.floor(Math.random() * 1e12));
        this.isWebSocketOpen = false;
        this.socketChannel = null;
        this.socketAttempts = 0;
        this.handleReconnectAttempt = function () {
            _this.socketChannel.io.opts.transports = _this.attemptTransports;
        };
        this.handleConnectError = function (connectError) {
            var _a, _b, _c;
            util_1.ConnectionLog.info("socket io connect_error, isOnline:" + netcheck_1.network.isOnline + ", type:" + (connectError === null || connectError === void 0 ? void 0 : connectError.type) + ", code:" + (connectError === null || connectError === void 0 ? void 0 : connectError.code) + ",\n      message:" + (connectError === null || connectError === void 0 ? void 0 : connectError.message) + ", description:" + (connectError === null || connectError === void 0 ? void 0 : connectError.description));
            // 只有网络正常情况下，连接失败才进行监控
            if (netcheck_1.network.isOnline) {
                // description 可能为errorCode stack undefined
                var status_1 = typeof (connectError === null || connectError === void 0 ? void 0 : connectError.description) === 'number' ? connectError === null || connectError === void 0 ? void 0 : connectError.description : undefined;
                collab_room_reporter_1.default.reportSocketConnect({
                    attrName: 'SocketConnect',
                    status: 1 /* FAILED */,
                    module: (_a = _this.option) === null || _a === void 0 ? void 0 : _a.module,
                    errorMessage: (connectError === null || connectError === void 0 ? void 0 : connectError.message) + ", status:" + status_1,
                    transports: (_c = (_b = _this.socketChannel) === null || _b === void 0 ? void 0 : _b.io.opts.transports) === null || _c === void 0 ? void 0 : _c[transportsIndex],
                });
            }
            var channelInfo = _this.getSocketChannelInfo();
            channelInfo.event = "connect_error" /* connectError */;
            channelInfo.failReason = 'io connect_error unknown';
            if (connectError === null || connectError === void 0 ? void 0 : connectError.type) {
                channelInfo.failReason = connectError.type;
            }
            _this.option.roomWebSocketDependency.onSocketStatusChanged(channelInfo);
        };
        this.handleConnectTimeout = function (timeout) {
            var _a, _b, _c;
            var channelInfo = _this.getSocketChannelInfo();
            channelInfo.event = "connect_timeout" /* connectTimeout */;
            channelInfo.failReason = "connect_timeout timeout:" + timeout;
            _this.option.roomWebSocketDependency.onSocketStatusChanged(channelInfo);
            collab_room_reporter_1.default.reportSocketConnect({
                attrName: 'SocketConnect',
                status: 2 /* TIMEOUT */,
                module: (_a = _this.option) === null || _a === void 0 ? void 0 : _a.module,
                errorMessage: channelInfo.failReason,
                transports: (_c = (_b = _this.socketChannel) === null || _b === void 0 ? void 0 : _b.io.opts.transports) === null || _c === void 0 ? void 0 : _c[transportsIndex],
            });
        };
        /**
         * 自定义事件，收到服务器推送消息
         *
         * @private
         * @param {*} msg
         */
        this.handleMessageFromServerPush = function (msg) {
            // ConnectionLog.info(" ========== socket get =========== msg: " + msg);
            _this.option.roomWebSocketDependency.onGetMessageFromServerPush(msg);
        };
        /**
         * 自定义事件,提交消息之后的服务器回包消息
         *
         * @private
         * @param {*} msg
         */
        this.handlePost = function (msg) {
            // ConnectionLog.info(" ========== socket post =========== msg: " + msg);
            _this.option.roomWebSocketDependency.onPostFromServer(msg);
        };
        /**
         * 连接成功
         *
         * @private
         */
        this.handleConnect = function () {
            var _a, _b, _c, _d, _e;
            util_1.ConnectionLog.info("socket io connect readyState: " + ((_a = _this.socketChannel) === null || _a === void 0 ? void 0 : _a.io.readyState) + ", id:" + ((_b = _this.socketChannel) === null || _b === void 0 ? void 0 : _b.id));
            collab_room_reporter_1.default.reportSocketConnect({
                module: (_c = _this.option) === null || _c === void 0 ? void 0 : _c.module,
                attrName: 'SocketConnect',
                status: 0 /* SUCCESS */,
                errorMessage: 'Success',
                transports: (_e = (_d = _this.socketChannel) === null || _d === void 0 ? void 0 : _d.io.opts.transports) === null || _e === void 0 ? void 0 : _e[transportsIndex],
            });
            _this.isWebSocketOpen = true;
            _this.option.roomWebSocketDependency.onSocketOpen();
        };
        /**
         * 每一次重连前触发（reconnecting之前）
         *
         * @private
         * @param {number} attemptNumber
         */
        this.handleReconnect = function (attemptNumber) {
            var _a, _b, _c;
            // 表示已经重新连接上了，open状态，attemptNumber为重试次数
            var errorMessage = "socket io reconnect number: " + attemptNumber + " channel.readyState: " + _this.socketChannel.io.readyState;
            util_1.ConnectionLog.info(errorMessage);
            _this.socketAttempts = 0;
            // 成功量较大，采样1%上报
            Math.random() < 0.01 && collab_room_reporter_1.default.reconnectReport({
                attrName: 'SocketReconnect',
                status: 0 /* SUCCESS */,
                module: (_a = _this.option) === null || _a === void 0 ? void 0 : _a.module,
                errorMessage: errorMessage,
                transports: (_c = (_b = _this.socketChannel) === null || _b === void 0 ? void 0 : _b.io.opts.transports) === null || _c === void 0 ? void 0 : _c[transportsIndex],
            });
        };
        /**
         * 每一次重连前触发
         *
         * @private
         * @param {number} attemptNumber
         */
        this.handleReconnecting = function (attemptNumber) {
            _this.socketAttempts = attemptNumber;
            _this.socketChannel.io.opts.transports = _this.initTransports;
            // socket.io 内部的最后一次重试才切换到到polling模式
            if (_this.option.roomWebSocketDependency.onReopenCount()
                >= _this.option.websocketReopenCount
                && (attemptNumber >= _this.option.pollingAttemptNumber)) {
                _this.socketChannel.io.opts.transports = _this.attemptTransports;
            }
            util_1.ConnectionLog.info("socket io reconnecting number:" + attemptNumber + " readyState: " + _this.socketChannel.io.readyState + ", transports:" + _this.socketChannel.io.opts.transports);
            var channelInfo = _this.getSocketChannelInfo();
            channelInfo.event = "reconnecting" /* reconnecting */;
            _this.option.roomWebSocketDependency.onSocketStatusChanged(channelInfo);
        };
        this.handleRetry = function (msg) {
            util_1.ConnectionLog.info("socket io retry, msg:" + msg);
            _this.doDisconnect('Server restarted or socket timed out on server. serverRetry offlineEdit');
        };
        /**
         * 断开事件处理
         *
         * @private
         * @param {*} msg
         */
        this.handleDisconnect = function (msg) {
            var _a, _b, _c, _d;
            // 这里可能有两种情况，一种是服务器断了，另一种是客户端断网，代码调用disconnect也会触发
            util_1.ConnectionLog.info("socket io disconnect, msg: " + util_1.JsonUtil.jsonStringify(msg) + " channel.readyState: " + ((_a = _this.socketChannel) === null || _a === void 0 ? void 0 : _a.io.readyState));
            var reason = util_1.JsonUtil.jsonStringify(msg) + "\uFF0CClosedByOthers.";
            var channelInfo = _this.getSocketChannelInfo();
            channelInfo.event = "disconnect" /* disconnect */;
            channelInfo.disconnectReason = "" + reason;
            channelInfo.socketId = _this.socketId;
            _this.option.roomWebSocketDependency.onSocketStatusChanged(channelInfo);
            _this.socketAttempts = 0;
            collab_room_reporter_1.default.reportSocketConnect({
                attrName: 'SocketDisconnect',
                status: 1 /* FAILED */,
                module: (_b = _this.option) === null || _b === void 0 ? void 0 : _b.module,
                errorMessage: channelInfo.disconnectReason,
                transports: (_d = (_c = _this.socketChannel) === null || _c === void 0 ? void 0 : _c.io.opts.transports) === null || _d === void 0 ? void 0 : _d[transportsIndex],
            });
        };
        /**
         * 连接失败
         *
         * @private
         * @param {*} msg
         */
        this.handleConnectFailed = function (msg) {
            util_1.ConnectionLog.info('socket io connect_failed');
            _this.socketAttempts = 0;
            _this.doDisconnect(util_1.JsonUtil.jsonStringify(msg) + "  connect_failed Closed by client.");
        };
        /**
         * 连接错误
         *
         * @private
         * @param {*} msg
         */
        this.handleError = function (connectError) {
            var _a, _b, _c;
            var errorMessage = "type:" + (connectError === null || connectError === void 0 ? void 0 : connectError.type) + ", code:" + (connectError === null || connectError === void 0 ? void 0 : connectError.code) + ",\n    message:" + (connectError === null || connectError === void 0 ? void 0 : connectError.message) + ", description:" + (connectError === null || connectError === void 0 ? void 0 : connectError.description);
            util_1.ConnectionLog.info("socket io error, " + errorMessage);
            _this.doDisconnect(util_1.JsonUtil.jsonStringify(connectError) + " socket io error Closed by client.");
            collab_room_reporter_1.default.reportSocketConnect({
                attrName: 'SocketError',
                status: 1 /* FAILED */,
                module: (_a = _this.option) === null || _a === void 0 ? void 0 : _a.module,
                errorMessage: errorMessage,
                transports: (_c = (_b = _this.socketChannel) === null || _b === void 0 ? void 0 : _b.io.opts.transports) === null || _c === void 0 ? void 0 : _c[transportsIndex],
            });
        };
        /**
         * 重连失败
         *
         * @private
         * @param {*} msg
         */
        this.handleReconnectFailed = function (msg) {
            var _a, _b, _c;
            // 在规定重连次数内不能连接上时触发
            util_1.ConnectionLog.info('socket io reconnect_failed');
            _this.socketAttempts = 0;
            var errorMessage = util_1.JsonUtil.jsonStringify(msg) + " reconnect_failed Closed by client.";
            _this.doDisconnect(errorMessage);
            collab_room_reporter_1.default.reportSocketConnect({
                attrName: 'SocketReconnect',
                status: 1 /* FAILED */,
                module: (_a = _this.option) === null || _a === void 0 ? void 0 : _a.module,
                errorMessage: errorMessage,
                transports: (_c = (_b = _this.socketChannel) === null || _b === void 0 ? void 0 : _b.io.opts.transports) === null || _c === void 0 ? void 0 : _c[transportsIndex],
            });
        };
        this.handleReconnectError = function (connectError) {
            var _a, _b, _c;
            var status = typeof (connectError === null || connectError === void 0 ? void 0 : connectError.description) === 'number' ? connectError === null || connectError === void 0 ? void 0 : connectError.description : undefined;
            var errorMessage = (connectError === null || connectError === void 0 ? void 0 : connectError.message) + ", status:" + status;
            collab_room_reporter_1.default.reportSocketConnect({
                attrName: 'SocketReconnect',
                status: 1 /* FAILED */,
                module: (_a = _this.option) === null || _a === void 0 ? void 0 : _a.module,
                errorMessage: errorMessage,
                transports: (_c = (_b = _this.socketChannel) === null || _b === void 0 ? void 0 : _b.io.opts.transports) === null || _c === void 0 ? void 0 : _c[transportsIndex],
            });
            util_1.ConnectionLog.info("socket io reconnect_error, " + errorMessage);
        };
        this.initTransports = this.getTransports(option.wmode);
        this.attemptTransports = this.getAttemptTransports(option.wmode);
    }
    /**
     * 模块内部销毁
     *
     */
    RoomWebsocket.prototype.dispose = function () {
        this.disconnect('socket io dispose');
    };
    /**
     * 获取连接状态
     *
     */
    RoomWebsocket.prototype.isConnected = function () {
        return this.isWebSocketOpen;
    };
    /**
     * 主动建立连接
     *
     */
    RoomWebsocket.prototype.connect = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function () {
            var protocol, url, channelOptions, token, channel;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        protocol = ((_b = (_a = this.option.config) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.protocol) ? ((_d = (_c = this.option.config) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.protocol) + ":" : 'wss:';
                        url = protocol + "//" + ((_g = (_f = (_e = this.option.config) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.host) !== null && _g !== void 0 ? _g : window.location.host);
                        channelOptions = {
                            query: {
                                tag: this.option.tag,
                                gtag: this.option.gid,
                                utag: this.option.upid,
                                sig: this.option.sig,
                                uid: this.option.uid,
                                uid_key: this.option.uidKey,
                                u: this.option.nowUserIndex,
                                padid: this.option.padId,
                            },
                            transports: this.initTransports,
                            reconnection: true,
                            reconnectionAttempts: config_1.WEBSOCKET_CONFIG.reconnectMaxTimes,
                            reconnectionDelay: config_1.WEBSOCKET_CONFIG.reconnectionDelay,
                            reconnectionDelayMax: config_1.WEBSOCKET_CONFIG.reconnectionDelayMax,
                            randomizationFactor: config_1.WEBSOCKET_CONFIG.randomizationFactor,
                            timeout: config_1.WEBSOCKET_CONFIG.connectTimeout,
                            path: (_k = (_j = (_h = this.option.config) === null || _h === void 0 ? void 0 : _h.location) === null || _j === void 0 ? void 0 : _j.path) !== null && _k !== void 0 ? _k : '/websocket',
                        };
                        if (!util_1.isWebOffice) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _l.sent();
                        channelOptions.transportOptions = {
                            websocket: {
                                protocols: token,
                            },
                        };
                        _l.label = 2;
                    case 2:
                        channel = socket_io_client_1.default(url, channelOptions);
                        this.socketChannel = channel;
                        util_1.ConnectionLog.info("socket io new channel transports: " + channel.io.opts.transports + ", pollingReopenCount =\n      " + this.option.websocketReopenCount + ", pollingAttemptNumber= " + this.option.pollingAttemptNumber);
                        /**
                         * socket.io 事件文档：https://socket.io/docs/v2/client-api/#events
                         */
                        channel.on('reconnect_attempt', this.handleReconnectAttempt);
                        channel.on('connect_error', this.handleConnectError);
                        channel.on('connect_timeout', this.handleConnectTimeout);
                        channel.on('get', this.handleMessageFromServerPush);
                        channel.on('post', this.handlePost);
                        channel.on('connect', this.handleConnect);
                        channel.on('reconnect', this.handleReconnect);
                        channel.on('reconnecting', this.handleReconnecting);
                        channel.on('retry', this.handleRetry);
                        channel.on('disconnect', this.handleDisconnect);
                        channel.on('connect_failed', this.handleConnectFailed);
                        channel.on('error', this.handleError);
                        channel.on('reconnect_failed', this.handleReconnectFailed);
                        channel.on('reconnect_error', this.handleReconnectError);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *  直接发送，替换postMessage
     *
     * @param {*} data
     */
    RoomWebsocket.prototype.postMessageForWebSocket = function (data) {
        if (this.socketChannel) {
            this.socketChannel.emit('post', data);
        }
    };
    /**
     * 获取Websocket重连多少次
     *
     */
    RoomWebsocket.prototype.getSocketConnectCount = function () {
        return this.socketAttempts;
    };
    RoomWebsocket.prototype.getSocketChannelInfo = function () {
        var info = {};
        if (this.socketChannel) {
            info.connected = this.socketChannel.connected;
            info.disconnected = this.socketChannel.disconnected;
            if (this.socketChannel.io) {
                info.readyState = this.socketChannel.io.readyState;
                info.reconnecting = this.socketChannel.io.reconnecting;
            }
        }
        return info;
    };
    /**
     * 外部断开Websocket连接
     *
     * @param {string} reason
     */
    RoomWebsocket.prototype.disconnect = function (reason) {
        util_1.ConnectionLog.info("socket io disconnect reason: " + reason);
        if (this.socketChannel) {
            this.socketChannel.disconnect();
            this.socketChannel = null;
        }
        this.isWebSocketOpen = false;
    };
    /**
     * 获取连接模式
     *
     * @private
     * @param {string} md
     * @returns {*}  {string[]}
     */
    RoomWebsocket.prototype.getTransports = function (md) {
        return config_1.TRANSPOET_MODE_MAP.get(md.charAt(0)) || config_1.DEFAULT_TRANSPORT_MODE;
    };
    /**
     * 重连模式
     *
     * @private
     * @param {string} md
     * @returns {*}  {string[]}
     */
    RoomWebsocket.prototype.getAttemptTransports = function (md) {
        return config_1.TRANSPOET_MODE_MAP.get(md.charAt(1)) || config_1.DEFAULT_ATTEMPT_TRANSPORT_MODE;
    };
    /**
     * 断开连接，销毁对象
     *
     * @private
     * @param {string} reason
     */
    RoomWebsocket.prototype.doDisconnect = function (reason) {
        this.disconnect("socket io doDisconnect reason: " + reason);
        this.option.roomWebSocketDependency.onSocketClosed(reason);
    };
    /**
     * 获取加密后的token
     * @returns
     */
    RoomWebsocket.prototype.getToken = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var appId, token, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        appId = util_1.getURLParam(APPID_QUERY_KEY);
                        token = (_a = window.userToken) !== null && _a !== void 0 ? _a : '';
                        return [4 /*yield*/, axios_1.default.post('/api/weboffice/session', { appId: appId, token: token, })];
                    case 1:
                        data = (_b.sent()).data;
                        return [2 /*return*/, data.retcode === 0 ? data.result.token : []];
                }
            });
        });
    };
    return RoomWebsocket;
}());
exports.RoomWebsocket = RoomWebsocket;
